var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasteque(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 34,
    viewBox: "0 0 68 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E74536",
    d: "M31.58 0a3.568 3.568 0 01-4.65 3.4 5.967 5.967 0 01-4.914 2.578A5.978 5.978 0 0116.038 0H4.082c0 16.514 13.385 29.89 29.89 29.89 16.505 0 29.89-13.385 29.89-29.89H31.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB511",
    d: "M4.082 0c0 16.514 13.385 29.89 29.89 29.89 16.505 0 29.89-13.385 29.89-29.89h4.082c0 18.765-15.207 33.972-33.972 33.972S0 18.765 0 0h4.082z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.928,
    cy: 14.469,
    r: 2.587,
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.972,
    cy: 19.718,
    r: 2.587,
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.016,
    cy: 14.469,
    r: 2.587,
    fill: "#0F1941"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2OCIgaGVpZ2h0PSIzNCIgdmlld0JveD0iMCAwIDY4IDM0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZmlsbD0iI0U3NDUzNiIgZD0iTTMxLjU4IDBhMy41NjggMy41NjggMCAwIDEtNC42NSAzLjQgNS45NjcgNS45NjcgMCAwIDEtNC45MTQgMi41NzhBNS45NzggNS45NzggMCAwIDEgMTYuMDM4IDBINC4wODJjMCAxNi41MTQgMTMuMzg1IDI5Ljg5IDI5Ljg5IDI5Ljg5IDE2LjUwNSAwIDI5Ljg5LTEzLjM4NSAyOS44OS0yOS44OUgzMS41ODF6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGQjUxMSIgZD0iTTQuMDgyIDBjMCAxNi41MTQgMTMuMzg1IDI5Ljg5IDI5Ljg5IDI5Ljg5IDE2LjUwNSAwIDI5Ljg5LTEzLjM4NSAyOS44OS0yOS44OWg0LjA4MmMwIDE4Ljc2NS0xNS4yMDcgMzMuOTcyLTMzLjk3MiAzMy45NzJTMCAxOC43NjUgMCAwaDQuMDgyeiIvPgogICAgICAgIDxjaXJjbGUgY3g9IjQ1LjkyOCIgY3k9IjE0LjQ2OSIgcj0iMi41ODciIGZpbGw9IiMwRjE5NDEiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIzMy45NzIiIGN5PSIxOS43MTgiIHI9IjIuNTg3IiBmaWxsPSIjMEYxOTQxIi8+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIuMDE2IiBjeT0iMTQuNDY5IiByPSIyLjU4NyIgZmlsbD0iIzBGMTk0MSIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgPasteque as ReactComponent };